<script setup lang="tsx">
import InstanceView from '@/components/widgets/InstanceView.vue'
import { onMounted, ref } from 'vue'

const props = defineProps({
	id: String,
	class: String,
	title: String,
	dataTest: String,
})
const isScrolled = ref(false)

const handleScroll = () => {
	isScrolled.value = window.scrollY > 0
}

onMounted(() => {
	window.addEventListener('scroll', handleScroll)
})
</script>

<template>
	<header :class="['fixed-top header', { 'scrolled-header': isScrolled }]">
		<h1 :data-test="props.dataTest">
			{{ props.title }}
		</h1>

		<InstanceView></InstanceView>
		<div class="right-side">
			<slot class="col-sm min-vh-100" name="right-side"></slot>
		</div>
		<div class="bottom-bar"></div>
	</header>
	<div class="spacer"></div>
</template>

<style lang="sass" scoped>
:deep(.header)
  background-color: var(--bs-body-bg)

.header
  margin-left: 96px
  top: 0
  right: 0
  background-color: var(--bs-body-bg)
  width: calc(100% - 96px)
  display: flex
  justify-content: space-between
  align-items: center
  padding: 0.5rem 0.8rem
  height: 80px
  transition: height 0.3s ease-in-out
  flex-wrap: nowrap

.h1
  @media (max-width: 1000px)
    transform: scale(0.9)
  @media (max-width: 800px)
    transform: scale(0.8)

.scrolled-header
  height: 60px
  opacity: 0.95

.bottom-bar
  height: 1px
  width: 100%
  position: absolute
  bottom: 0
  left: 0
  opacity: 0.95
  box-shadow: 0 1px 3px rgb(0 0 0 / 24%)

.spacer
  height: 80px
  @media (max-width: 850px)
    height: 130px

.right-side
  @media (max-width: 1000px)
    transform: scale(0.9)
  @media (max-width: 900px)
    transform: scale(0.8)

@media (max-width: 850px)
  .header
    flex-direction: column
    align-items: center
    justify-content: center
    height: auto
    gap: 3.5rem
</style>
